import { CSSObject } from '@core-ui/react-stitch';

const copyblockStyles = (isMobileStyle: boolean): CSSObject => ({
  display: 'flex',
  maxWidth: '1280px',
  margin: 'auto',
  padding: isMobileStyle ? '2rem 0.5rem 0' : '0 0.5rem 2.5rem 17.5rem',
  overflow: 'hidden',
  color: '#999',
  whiteSpace: 'pre-line',
  a: {
    cursor: 'pointer',
    color: 'blue'
  }
});

export default copyblockStyles;
